<template>
  <el-card class="h-full">
    <div>
      <el-input
        size="small"
        clearable
        placeholder="请输入关键字"
        class="!w-280px mr-10px"
        v-model="keyWord"
      />
      <el-button type="primary" @click="searchList()" size="small">搜索</el-button>
      <el-button size="small" type="primary" @click="addTenant()">新增</el-button>
    </div>
    <el-table
      height="calc(100% - 106px)"
      class="mt-20px"
      border
      :data="tableData"
      @sort-change="sortChangeTable"
      v-loading="loading"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
    >
      <el-table-column
        label="租户名称"
        prop="name"
        sortable
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="租户id" prop="id" show-overflow-tooltip></el-table-column>
      <el-table-column label="管理员邮箱" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.extraProperties.Email }}
        </template>
      </el-table-column>
      <el-table-column label="描述" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.extraProperties.Desc }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="120">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.extraProperties.IsActive"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="setActive(scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column width="235" show-overflow-tooltip label="操作">
        <template slot-scope="scope">
          <el-button @click="resetPassword(scope.row)" size="mini">重置密码</el-button>
          <el-button @click="editTenant(scope.row)" size="mini">编辑</el-button>
          <el-button size="mini" @click="deleteTenement(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="text-right mt-20px"
      background
      @size-change="searchList()"
      @current-change="findList()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :total="page.pageTotal"
      layout="sizes, total, prev, pager, next, jumper"
      :pager-count="5"
      :page-sizes="[15, 30, 50, 100]"
    >
    </el-pagination>
    <operate-tenant-dialog
      :visible="showOperateTenantDialog"
      :title="dialogTitle"
      :operateRules="operateRules"
      :formItemList="formItemList"
      @save="operateSave"
      @closed="showOperateTenantDialog = false"
      :saveLoading="saveLoading"
    ></operate-tenant-dialog>
  </el-card>
</template>
<script>
import { TenantApi } from '@wiz-api/abp-tenant-management'
import { EafTenantApi } from '@wiz-api/eaf-tenant-management'

const OperateTenantDialog = () => {
  return import('../components/OperateTenantDialog')
}
const tenantApi = new TenantApi()
const eafTenantApi = new EafTenantApi()
const validateEmail = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('必填'))
  } else if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(value)) {
    callback(new Error('请输入正确的邮箱格式!'))
  } else {
    callback()
  }
}
export default {
  name: 'tenant',
  components: {
    OperateTenantDialog,
  },
  data() {
    return {
      keyWord: '',
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      tableData: [],
      sort: {
        type: '',
        sortName: 'name',
      },
      loading: false,
      showOperateTenantDialog: false,
      dialogTitle: '', // 弹窗标题
      operateRules: {}, // 表单校验规则
      formItemList: [], // 表单项列表
      saveLoading: false,
    }
  },
  created() {
    this.searchList()
  },
  methods: {
    /**
     * @description: 新增租户
     * @param {*}
     * @return {*}
     */
    addTenant() {
      this.formItemList = [
        {
          label: '租户名称',
          prop: 'name',
          type: 'text',
        },
        {
          label: '管理员密码',
          prop: 'adminPassword',
          type: 'password',
        },
        {
          label: '管理员邮箱',
          prop: 'adminEmailAddress',
          type: 'text',
        },
        {
          label: '描述',
          prop: 'desc',
          type: 'textarea',
        },
      ]
      this.operateRules = {
        name: [{ required: true, message: '必填', trigger: 'blur' }],
        adminPassword: [{ required: true, message: '必填', trigger: 'blur' }],
        adminEmailAddress: [{ required: true, validator: validateEmail, trigger: 'blur' }],
        desc: [{ required: true, message: '必填', trigger: 'blur' }],
      }
      this.dialogTitle = '新增租户'
      this.showOperateTenantDialog = true
    },
    async operateSave(form) {
      this.saveLoading = true
      let [err] = []
      switch (this.dialogTitle) {
        case '新增租户':
          ;[err] = await tenantApi.create({
            body: {
              ..._.pick(form, ['name', 'adminPassword', 'adminEmailAddress']),
              extraProperties: {
                Desc: form.desc,
              },
            },
          })
          break
        case '编辑租户':
          ;[err] = await tenantApi.update(form.id, {
            body: {
              ..._.pick(form, ['name']),
              extraProperties: {
                Desc: form.desc,
              },
            },
          })
          break
        default:
          break
      }
      this.saveLoading = false
      if (!err) {
        this.$message.success(`${this.dialogTitle}成功!`)
        this.showOperateTenantDialog = false
        this.searchList()
      }
    },
    // 重置密码
    resetPassword(row) {
      this.$confirm('此操作将会对密码进行重置，是否继续', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err] = await eafTenantApi.clearTenantAdminPasswordToDefault({
            body: {
              tenantId: row.id,
            },
          })
          if (!err) {
            this.$message.success('重置成功!')
          }
        })
        .catch(() => {})
    },
    // 启用/禁用
    setActive(row) {
      row.extraProperties.IsActive = !row.extraProperties.IsActive
      const statusName = `${row.extraProperties.IsActive ? '禁用' : '启用'}`
      this.$confirm(`此操作将会对租户进行${statusName}，是否继续`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await eafTenantApi.setTenantActive({
            body: {
              tenantId: row.id,
              isActive: !row.extraProperties.IsActive,
            },
          })
          if (!err) {
            this.$message.success(`${statusName}成功!`)
            this.findList()
          }
        })
        .catch(() => {})
    },
    sortChangeTable(sortColumn) {
      if (_.isNil(sortColumn.column)) {
        return
      }
      this.sort.type = sortColumn.order === 'ascending' ? 0 : 1
      this.sort.sortName = sortColumn.prop
      this.findList()
    },
    /**
     * @description: 修改租户
     * @param {*} row
     * @return {*}
     */
    async editTenant(row) {
      this.formItemList = [
        {
          label: '租户名称',
          prop: 'name',
          value: row.name,
          type: 'text',
        },
        {
          label: '描述',
          prop: 'desc',
          value: row.extraProperties.Desc,
          type: 'text',
        },
        {
          label: 'id',
          prop: 'id',
          hidden: true,
          value: row.id,
          type: 'text',
        },
      ]
      this.operateRules = {
        name: [{ required: true, message: '必填', trigger: 'blur' }],
        desc: [{ required: true, message: '必填', trigger: 'blur' }],
      }
      this.dialogTitle = '编辑租户'
      this.showOperateTenantDialog = true
    },
    async findList() {
      this.loading = true
      const [err, res] = await tenantApi.getList({
        filter: this.keyWord,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        sorting: `${this.sort.sortName} ${this.sort.type === 0 ? 'asc' : 'desc'}`,
      })
      if (!err) {
        this.tableData = res.items
        this.page.pageTotal = res.totalCount
      }
      this.loading = false
    },
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    /**
     * @description: 删除租户
     * @param {String} id
     */
    deleteTenement(id) {
      this.$confirm('确认要删除么', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err] = await tenantApi.callDelete(id)
          if (!err) {
            this.$message.success('删除成功')
            this.searchList()
          }
        })
        .catch(() => {})
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-card__body {
  height: calc(100%);
}
</style>
